import React from "react";

const data: { [code: string]: string } = {
  ar: "العربية",
  ca: "Català",
  cs: "Česky",
  cy: "Cymraeg",
  de: "Deutsch",
  en: "English",
  "es-ES": "Español",
  fi: "Suomi",
  fr: "Français",
  "ga-IE": "Gaeilge",
  he: "עברית",
  hr: "Hrvatski",
  hu: "Magyar",
  it: "Italiano",
  ja: "日本語",
  ko: "한국어",
  lt: "Lietuvių",
  nl: "Nederlands",
  // This isn't accurate as there are two Norwegian languages but best reflects how it was used in the archive site.
  no: "Norwegian Bokmal",
  pl: "Polski",
  "pt-PT": "Português (Portugal)",
  "pt-BR": "Português (Brasil)",
  si: "සිංහල",
  sr: "српски",
  sv: "Svenska",
  ta: "தமிழ்",
  "zh-CN": "简体中文",
  "zh-HK": "繁體中文（香港）",
  "zh-TW": "繁體中文（台灣）"
};

export const Language = ({ code }: { code: string }) => (
  <span>{getLanguageFromCode(code)}</span>
);

export const getLanguageFromCode = (code: string) => data[code || "en"] || code;
